// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*************************Sidenavigation Styles start******************************************/

.Reviews-listContainer-DJGyq {
  padding-left: 0px;
  list-style-type: none;
}

.Reviews-sideNavitem-ciUGS {
  display: block;
  padding: 6px 0;
  font-size: 16px;
  color: var(--modalText-color);
  text-decoration: none;
}

.Reviews-sideNavitem-ciUGS:hover {
  text-decoration: none;
  color: var(--common-text-color);
}

.Reviews-sideNavitem-ciUGS:active {
  text-decoration: none;
  color: var(--common-text-color);
  font-weight: bold;
}

.Reviews-sideNavitem-ciUGS:active {
  text-decoration: none;
  color: var(--common-text-color);
  font-weight: bold;
}

/*************************Sidenavigation Styles end******************************************/

.Reviews-panelHeader-DWXvZ {

  border-radius: 0;
  width: 100%;
  display: block;
  color: var(--common-text-color);
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);

}

.Reviews-listLayout-K8uOz {
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
  color: var(--common-text-color);
}

.Reviews-description-qezEy {
  font-size: 14px;
  line-height: 1.43;

}

a {
  text-decoration: none;
}

a:hover,
a:focus,
a:active {
  cursor: pointer;
  text-decoration: none;
}

.Reviews-space4-Y6vtb {
  margin-bottom: 24px;
}

.Reviews-space2-Fjvkj {
  margin-bottom: 12px;
}

.Reviews-spaceTop4-OPgg0 {
  margin-top: 24px;
}

.Reviews-spaceTop2-Qs78R {
  margin-top: 12px;
}

.Reviews-mediaContainer-YYqmn {
  display: table;
  position: relative;
}

.Reviews-profileAvatarLink-m0yKP {
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  position: relative;
  display: inline-block;
  overflow: hidden;
  background-color: var(--common-gray-bg-color);
  border-radius: 50%;
  border: 2px solid var(--primary-white-bg);
}

.Reviews-avatarDisplay-yLAlP {
  display: table-cell;
}

.Reviews-noBorder-WmrdA {
  border: 0px none !important;
}

.Reviews-panelNolist-PzAsD {
  border-radius: 0;
  width: 100%;
  display: block;
  color: var(--common-text-color);
  font-size: 14px;
  line-height: 1.43;
  background: var(--primary-white-bg);
}

.Reviews-textCenter-qIH_R {
  text-align: center;
  position: relative;
  z-index: 5;
}

.Reviews-textBold-SmRnK {
  font-weight: bold;
}

.Reviews-pullLeft-m4KGw {
  float: left;
  margin-right: 2px;
}

.Reviews-listStyle-tr0I8 {
  list-style: none;
  padding-left: 0;
}

.Reviews-mediaDisplay-kY0ZN {
  display: table;
  width: 100%;
}

.Reviews-mediaDisplayCell-To0If {
  display: table-cell;
}

.Reviews-name-DAnkW {
  margin: 4px 0;
  max-width: 74px;
  word-wrap: break-word;
  font-size: 12px;
}

.Reviews-reviewMuted-G8EHc {
  color: var(--modalText-color);
}

.Reviews-reviewTitle-G26Th {
  font-weight: bold;
  color: var(--common-text-color);
}

.Reviews-iconColor-rGe1T {
  color: var(--btn-primary-bg);
  font-size: 16px;

}

.Reviews-horizontalLineThrough-flBX0 {
  position: relative;
  z-index: 1;
  display: block;
  margin: 15px 0px;
  width: 100%;
  color: var(--modalText-color);
  text-align: center;
  font-size: 14px;
}

.Reviews-showSm-lI45x {
  display: none;
}

.Reviews-noListingTop-cWmzF {
  margin-top: 66px;
}

@media screen and (max-width: 640px) {
  .Reviews-mediaDisplay-kY0ZN {
    display: block;
  }

  .Reviews-textAlignCenter-SLBCj {
    text-align: left;
  }
}

@media screen and (max-width: 743px) {
  .Reviews-name-DAnkW {
    width: 100%;
    max-width: 100%;
  }

  .Reviews-mediaContainer-YYqmn {
    display: block;
    text-align: center;
  }

  .Reviews-avatarWrapper-fDA1M {
    float: none;
  }

  .Reviews-pullLeft-m4KGw {
    float: none;
  }
}

.Reviews-recommondations-pxd1_ {
  position: relative;
}

.Reviews-recommondations-pxd1_ li:last-child .Reviews-horizontalLineThrough-flBX0 {
  opacity: 0;
  height: 0;
  margin: 0px;
}

.Reviews-btn-i587V {
  padding: 7px 21px;
  border-color: var(--primary-border);
  background: var(--primary-white-bg);
  color: var(--common-text-color);
  font-weight: bold;
  font-size: 14px;
  border-radius: 0px;
}

.Reviews-btnPrimary-_VKLf {
  border-color: var(--btn-primary-bg);
  background-color: var(--btn-primary-bg);
  color: var(--white-text);
  font-family: inherit;
}

.Reviews-btnPrimary-_VKLf:hover,
.Reviews-btnPrimary-_VKLf:focus,
.Reviews-btnPrimary-_VKLf:active,
.Reviews-btnPrimary-_VKLf:active:hover,
.Reviews-btnPrimary-_VKLf:active:focus {
  border-color: var(--btn-primary-bg);
  background-color: var(--btn-primary-bg);
  color: var(--white-text);
}

.Reviews-btnPrimaryBorder-xNcUY {
  border-color: var(--btn-primary-bg);
  color: var(--btn-primary-bg);
  background-color: var(--primary-white-bg);

}

.Reviews-btnPrimaryBorder-xNcUY:hover,
.Reviews-btnPrimaryBorder-xNcUY:focus,
.Reviews-btnPrimaryBorder-xNcUY:active,
.Reviews-btnPrimaryBorder-xNcUY:active:hover,
.Reviews-btnPrimaryBorder-xNcUY:active:focus {
  border-color: var(--btn-primary-bg);
  color: var(--btn-primary-bg);
  background-color: var(--primary-white-bg);
}

.Reviews-btnRadius-HhW1B {
  border-radius: 0px;
}

.Reviews-linkBtn-ppKmO {
  border-radius: 4px;
  padding: 9px 21px;
}

.Reviews-noBackground-c_8Oz {
  background: transparent !important;
}

.Reviews-displayTable-UWMwe {
  display: table;
  width: 100%;
  background: var(--primary-white-bg);
  border-radius: 30px;
  padding: 10px;
  border: 1px solid var(--primary-border);
}

.Reviews-displayTableRow-s7kni {
  display: table-row;
  width: 100%;
}

.Reviews-displayTableCell-tyzAy {
  display: table-cell;
  vertical-align: middle;
}

.Reviews-rightBg-Z8hxN {
  background: var(--primary-white-bg);
  padding: 6px 15px;
  position: relative;
  width: 100%;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  margin-left: 5px;
}

.Reviews-LeftBg-Rmfbu {
  width: 10%;
}

.Reviews-marginTop-SFyNv {
  margin-top: 20px;
}

.Reviews-active-pblRw .Reviews-tabItem-tYZQH {
  color: var(--common-text-color);
  border-color: var(--common-link-color);
  text-decoration: none;
  font-weight: 500;
}

.Reviews-searchReviewInput-lFktC {
  max-width: 340px;
}

.Reviews-reviewYoursAdminImg-QPe75 {
  position: relative;
  z-index: 5;
}

.Reviews-reviewYoursAdminImg-QPe75 img {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}

.Reviews-dateReviewCss-fWprx {
  word-break: break-word;
}

.Reviews-rightText-s99sC {
  text-align: right;
}

.Reviews-iconPadRight-WUyu2 {
  padding-right: 4px;
}

@media screen and (max-width: 767px) {
  .Reviews-LeftBg-Rmfbu {
    vertical-align: top;
  }

  .Reviews-rightBg-Z8hxN {
    padding: 0px 15px;
  }

  .Reviews-mobileFlexContainer-oJKTQ {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .Reviews-mobileFlexContainer-oJKTQ li {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Reviews/Reviews.css"],"names":[],"mappings":"AAAA,+FAA+F;;AAE/F;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,6FAA6F;;AAE7F;;EAEE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,8CAA8C;;AAEhD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,iBAAiB;;AAEnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;;AAEjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,wBAAwB;EACxB,oBAAoB;AACtB;;AAGA;;;;;EAKE,mCAAmC;EACnC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,yCAAyC;;AAE3C;;AAEA;;;;;EAKE,mCAAmC;EACnC,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;AACF","sourcesContent":["/*************************Sidenavigation Styles start******************************************/\n\n.listContainer {\n  padding-left: 0px;\n  list-style-type: none;\n}\n\n.sideNavitem {\n  display: block;\n  padding: 6px 0;\n  font-size: 16px;\n  color: var(--modalText-color);\n  text-decoration: none;\n}\n\n.sideNavitem:hover {\n  text-decoration: none;\n  color: var(--common-text-color);\n}\n\n.sideNavitem:active {\n  text-decoration: none;\n  color: var(--common-text-color);\n  font-weight: bold;\n}\n\n.sideNavitem:active {\n  text-decoration: none;\n  color: var(--common-text-color);\n  font-weight: bold;\n}\n\n/*************************Sidenavigation Styles end******************************************/\n\n.panelHeader {\n\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  color: var(--common-text-color);\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n\n}\n\n.listLayout {\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none;\n  color: var(--common-text-color);\n}\n\n.description {\n  font-size: 14px;\n  line-height: 1.43;\n\n}\n\na {\n  text-decoration: none;\n}\n\na:hover,\na:focus,\na:active {\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.space4 {\n  margin-bottom: 24px;\n}\n\n.space2 {\n  margin-bottom: 12px;\n}\n\n.spaceTop4 {\n  margin-top: 24px;\n}\n\n.spaceTop2 {\n  margin-top: 12px;\n}\n\n.mediaContainer {\n  display: table;\n  position: relative;\n}\n\n.profileAvatarLink {\n  backface-visibility: hidden;\n  position: relative;\n  display: inline-block;\n  overflow: hidden;\n  background-color: var(--common-gray-bg-color);\n  border-radius: 50%;\n  border: 2px solid var(--primary-white-bg);\n}\n\n.avatarDisplay {\n  display: table-cell;\n}\n\n.noBorder {\n  border: 0px none !important;\n}\n\n.panelNolist {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  color: var(--common-text-color);\n  font-size: 14px;\n  line-height: 1.43;\n  background: var(--primary-white-bg);\n}\n\n.textCenter {\n  text-align: center;\n  position: relative;\n  z-index: 5;\n}\n\n.textBold {\n  font-weight: bold;\n}\n\n.pullLeft {\n  float: left;\n  margin-right: 2px;\n}\n\n.listStyle {\n  list-style: none;\n  padding-left: 0;\n}\n\n.mediaDisplay {\n  display: table;\n  width: 100%;\n}\n\n.mediaDisplayCell {\n  display: table-cell;\n}\n\n.name {\n  margin: 4px 0;\n  max-width: 74px;\n  word-wrap: break-word;\n  font-size: 12px;\n}\n\n.reviewMuted {\n  color: var(--modalText-color);\n}\n\n.reviewTitle {\n  font-weight: bold;\n  color: var(--common-text-color);\n}\n\n.iconColor {\n  color: var(--btn-primary-bg);\n  font-size: 16px;\n\n}\n\n.horizontalLineThrough {\n  position: relative;\n  z-index: 1;\n  display: block;\n  margin: 15px 0px;\n  width: 100%;\n  color: var(--modalText-color);\n  text-align: center;\n  font-size: 14px;\n}\n\n.showSm {\n  display: none;\n}\n\n.noListingTop {\n  margin-top: 66px;\n}\n\n@media screen and (max-width: 640px) {\n  .mediaDisplay {\n    display: block;\n  }\n\n  .textAlignCenter {\n    text-align: left;\n  }\n}\n\n@media screen and (max-width: 743px) {\n  .name {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .mediaContainer {\n    display: block;\n    text-align: center;\n  }\n\n  .avatarWrapper {\n    float: none;\n  }\n\n  .pullLeft {\n    float: none;\n  }\n}\n\n.recommondations {\n  position: relative;\n}\n\n.recommondations li:last-child .horizontalLineThrough {\n  opacity: 0;\n  height: 0;\n  margin: 0px;\n}\n\n.btn {\n  padding: 7px 21px;\n  border-color: var(--primary-border);\n  background: var(--primary-white-bg);\n  color: var(--common-text-color);\n  font-weight: bold;\n  font-size: 14px;\n  border-radius: 0px;\n}\n\n.btnPrimary {\n  border-color: var(--btn-primary-bg);\n  background-color: var(--btn-primary-bg);\n  color: var(--white-text);\n  font-family: inherit;\n}\n\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus {\n  border-color: var(--btn-primary-bg);\n  background-color: var(--btn-primary-bg);\n  color: var(--white-text);\n}\n\n.btnPrimaryBorder {\n  border-color: var(--btn-primary-bg);\n  color: var(--btn-primary-bg);\n  background-color: var(--primary-white-bg);\n\n}\n\n.btnPrimaryBorder:hover,\n.btnPrimaryBorder:focus,\n.btnPrimaryBorder:active,\n.btnPrimaryBorder:active:hover,\n.btnPrimaryBorder:active:focus {\n  border-color: var(--btn-primary-bg);\n  color: var(--btn-primary-bg);\n  background-color: var(--primary-white-bg);\n}\n\n.btnRadius {\n  border-radius: 0px;\n}\n\n.linkBtn {\n  border-radius: 4px;\n  padding: 9px 21px;\n}\n\n.noBackground {\n  background: transparent !important;\n}\n\n.displayTable {\n  display: table;\n  width: 100%;\n  background: var(--primary-white-bg);\n  border-radius: 30px;\n  padding: 10px;\n  border: 1px solid var(--primary-border);\n}\n\n.displayTableRow {\n  display: table-row;\n  width: 100%;\n}\n\n.displayTableCell {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.rightBg {\n  background: var(--primary-white-bg);\n  padding: 6px 15px;\n  position: relative;\n  width: 100%;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-top-right-radius: 4px;\n  margin-left: 5px;\n}\n\n.LeftBg {\n  width: 10%;\n}\n\n.marginTop {\n  margin-top: 20px;\n}\n\n.active .tabItem {\n  color: var(--common-text-color);\n  border-color: var(--common-link-color);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.searchReviewInput {\n  max-width: 340px;\n}\n\n.reviewYoursAdminImg {\n  position: relative;\n  z-index: 5;\n}\n\n.reviewYoursAdminImg img {\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n}\n\n.dateReviewCss {\n  word-break: break-word;\n}\n\n.rightText {\n  text-align: right;\n}\n\n.iconPadRight {\n  padding-right: 4px;\n}\n\n@media screen and (max-width: 767px) {\n  .LeftBg {\n    vertical-align: top;\n  }\n\n  .rightBg {\n    padding: 0px 15px;\n  }\n\n  .mobileFlexContainer {\n    flex-direction: column;\n  }\n\n  .mobileFlexContainer li {\n    display: block;\n    width: 100%;\n    margin-bottom: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listContainer": `Reviews-listContainer-DJGyq`,
	"sideNavitem": `Reviews-sideNavitem-ciUGS`,
	"panelHeader": `Reviews-panelHeader-DWXvZ`,
	"listLayout": `Reviews-listLayout-K8uOz`,
	"description": `Reviews-description-qezEy`,
	"space4": `Reviews-space4-Y6vtb`,
	"space2": `Reviews-space2-Fjvkj`,
	"spaceTop4": `Reviews-spaceTop4-OPgg0`,
	"spaceTop2": `Reviews-spaceTop2-Qs78R`,
	"mediaContainer": `Reviews-mediaContainer-YYqmn`,
	"profileAvatarLink": `Reviews-profileAvatarLink-m0yKP`,
	"avatarDisplay": `Reviews-avatarDisplay-yLAlP`,
	"noBorder": `Reviews-noBorder-WmrdA`,
	"panelNolist": `Reviews-panelNolist-PzAsD`,
	"textCenter": `Reviews-textCenter-qIH_R`,
	"textBold": `Reviews-textBold-SmRnK`,
	"pullLeft": `Reviews-pullLeft-m4KGw`,
	"listStyle": `Reviews-listStyle-tr0I8`,
	"mediaDisplay": `Reviews-mediaDisplay-kY0ZN`,
	"mediaDisplayCell": `Reviews-mediaDisplayCell-To0If`,
	"name": `Reviews-name-DAnkW`,
	"reviewMuted": `Reviews-reviewMuted-G8EHc`,
	"reviewTitle": `Reviews-reviewTitle-G26Th`,
	"iconColor": `Reviews-iconColor-rGe1T`,
	"horizontalLineThrough": `Reviews-horizontalLineThrough-flBX0`,
	"showSm": `Reviews-showSm-lI45x`,
	"noListingTop": `Reviews-noListingTop-cWmzF`,
	"textAlignCenter": `Reviews-textAlignCenter-SLBCj`,
	"avatarWrapper": `Reviews-avatarWrapper-fDA1M`,
	"recommondations": `Reviews-recommondations-pxd1_`,
	"btn": `Reviews-btn-i587V`,
	"btnPrimary": `Reviews-btnPrimary-_VKLf`,
	"btnPrimaryBorder": `Reviews-btnPrimaryBorder-xNcUY`,
	"btnRadius": `Reviews-btnRadius-HhW1B`,
	"linkBtn": `Reviews-linkBtn-ppKmO`,
	"noBackground": `Reviews-noBackground-c_8Oz`,
	"displayTable": `Reviews-displayTable-UWMwe`,
	"displayTableRow": `Reviews-displayTableRow-s7kni`,
	"displayTableCell": `Reviews-displayTableCell-tyzAy`,
	"rightBg": `Reviews-rightBg-Z8hxN`,
	"LeftBg": `Reviews-LeftBg-Rmfbu`,
	"marginTop": `Reviews-marginTop-SFyNv`,
	"active": `Reviews-active-pblRw`,
	"tabItem": `Reviews-tabItem-tYZQH`,
	"searchReviewInput": `Reviews-searchReviewInput-lFktC`,
	"reviewYoursAdminImg": `Reviews-reviewYoursAdminImg-QPe75`,
	"dateReviewCss": `Reviews-dateReviewCss-fWprx`,
	"rightText": `Reviews-rightText-s99sC`,
	"iconPadRight": `Reviews-iconPadRight-WUyu2`,
	"mobileFlexContainer": `Reviews-mobileFlexContainer-oJKTQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
